<template>
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect width="24" height="24" rx="3" fill="#FFD700" />
		<rect x="4" y="10.4" width="16" height="3.2" rx="1" fill="white" />
		<rect
			x="10.4"
			y="20"
			width="16"
			height="3.2"
			rx="1"
			transform="rotate(-90 10.4 20)"
			fill="white"
		/>
	</svg>
</template>

<script>
export default {
	name: "LuckyDicePositive",
};
</script>
